import { Tableau } from '../../common/utilities/TableauLog';
import { CookieKeys, IVizPortalCookies } from '../models/IVizPortalCookies';
import { Module } from '../Module';

enum SessionState {
  Exists,
  NoSession,
  Unknown
}

export class SessionService {
  private $cookies: IVizPortalCookies;
  private sessionState: SessionState;

  public static $inject = [
    '$cookies'
  ];

  constructor($cookies: IVizPortalCookies) {
    this.$cookies = $cookies;
    this.sessionState = SessionState.Unknown;
  }

  // Tableau Server sets two session cookies:
  // `workgroup_session_id`, which is not accessible to scripts (Http-Only)
  // `XSRF-TOKEN` is by design made available to scripts
  // All usages of this cookie should got through here, except in OneOffStaticScripts
  public getSessionId(): string {
    return this.$cookies.get(CookieKeys.XsrfToken);
  }

  public setSessionId(ticket: string): void {
    Tableau.Logger().info('set session to ' + ticket);
    this.sessionState = SessionState.Exists;
    this.$cookies.put(CookieKeys.XsrfToken, ticket);
  }

  private clearSessionId(): void {
    Tableau.Logger().info('clear session id');
    this.$cookies.remove(CookieKeys.XsrfToken);
  }

  public isSessionStateUnknown(): boolean {
    Tableau.Logger().info('checking if session is Unknown(2): it is ' + this.sessionState);
    return this.sessionState === SessionState.Unknown;
  }

  public getSessionCookieName(): string {
    return CookieKeys.XsrfToken;
  }

  public endSession(message: string): void {
    Tableau.Logger().info('ending session: ' + message);
    this.sessionState = SessionState.NoSession;
    this.clearSessionId();
  }

  // eventually this should go away? we should be able to set the cookie when we create a session
  public createSession(): void {
    this.sessionState = SessionState.Exists;
  }

  public isSessionCurrentlyValid(): boolean {
    return this.sessionState === SessionState.Exists;
  }

}

Module.instance().service('SessionService', SessionService);
